import { Tag } from 'antd';
import { consignOrderRefundStatusConst } from '../../../../constants/ConsignOrderRefund.const';

export const ConsignOrderRefundStatus = ({ status }) => {
  const colors = {
    Aprobado: 'green',
    Pendiente: 'warning',
    Cancelada: 'red',
  };

  return (
    <Tag color={colors[status] || consignOrderRefundStatusConst.DEFAULT}>
      {status || consignOrderRefundStatusConst.DEFAULT}
    </Tag>
  );
};
